import { Component, OnInit, Inject } from '@angular/core';
import { NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { MixpanelService } from './services/mix-panel.service';
import { Store } from '@ngxs/store';
import { map, filter, pairwise } from 'rxjs/operators';
import { AuthState } from './state-manager/state/auth.state';
import { DOCUMENT } from '@angular/common';
import LogRocket from 'logrocket';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Vórtx Cadastro Único';

  constructor(
    private router: Router,
    private mixpanelService: MixpanelService,
    private store: Store,
    @Inject(DOCUMENT) private _document: Document
  ) {}

  ngOnInit() {
    if (environment.production) {
      const logRocketApiKey = environment.logRocketApiKey;

      LogRocket.init(logRocketApiKey);
    }
    this.store
      .select(AuthState.User)
      .pipe(
        map((user) => {
          if (user) {
            this.mixpanelService.init(user.email);
            this.mixpanelService.people.set({
              name: user.fullname,
              $email: user.email,
              $last_login: new Date()
            });
            this.mixpanelService.panel.identify(user.email);

            if (environment.production) {
              LogRocket.identify(user.email, {
                name: user.fullname,
                email: user.email
              });
            }
          }
        })
      )
      .subscribe();

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.router.events
      .pipe(
        filter((e: any) => e instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((e: any) => {
        let url: string;
        let currentUrl: string;
        url = e[0].urlAfterRedirects;
        currentUrl = e[1].urlAfterRedirects;
      });
  }
}
